export const skyblue = "#00B3E6";
export const cerulean = "#0078a0";
